import {RangeDatePicker as RangeDatePickerBase} from '@logistics-frontend/blocks'
import {get} from '@logistics-frontend/utils'
import {useController, UseControllerReturn, useFormContext} from 'react-hook-form'

import {OmittedRangeDatePickerProps, RangeDatePickerProps} from '../RangeDatePicker.types'

const toRangeValue = <T,>(start: T | null, end: T | null) => (!!start && !!end ? {start, end} : null)

const toDateProps = (
  dateFromController: UseControllerReturn,
  dateToController: UseControllerReturn,
): OmittedRangeDatePickerProps => ({
  value: toRangeValue(get('field.value', dateFromController), get('field.value', dateToController)),
  onChange: ev => {
    dateFromController.field.onChange(ev?.start || null)
    dateToController.field.onChange(ev?.end || null)
  },
  error: Boolean(get('fieldState.error', dateFromController) || get('fieldState.error', dateToController)),
})

export function RangeDatePicker({dateFrom, dateTo, ...otherProps}: RangeDatePickerProps) {
  const {control} = useFormContext()

  const dateFromController = useController({control, ...dateFrom})
  const dateToController = useController({control, ...dateTo})

  const dateProps = toDateProps(dateFromController, dateToController)

  return <RangeDatePickerBase {...dateProps} {...otherProps} />
}
